// extracted by mini-css-extract-plugin
module.exports = {"heading":"BaseHeading-heading-d2sz-Wnuik type-display-2ROY6J59LM type-leadingTight-3_Dygk8CBc"};